// extracted by mini-css-extract-plugin
module.exports = {"card":"BesoinAideCard_card__iS3wm","title":"BesoinAideCard_title__pR3RW","description":"BesoinAideCard_description__XQn9e"};